const { Core, Utils, Events } = Global;
const { $loading } = Utils;

customElements.define('menu-drawer', class extends Core { 
    elements = {
        'modal': 'modal-container'
    }

    render() {

    }
})
document.addEventListener('DOMContentLoaded', () => {
    const navigations = document.querySelectorAll("nav.liquid-nav");
    const buttons = Array.from(document.querySelectorAll("button.tab-button"));
    const accordionHeaders = document.querySelectorAll('.footer-link-item.nested');

    const handleNavigationClick = (e) => {
        const clickedButton = e.target;
        if (clickedButton.nodeName === "BUTTON") {
            setActive(clickedButton);
        }
    };

    const handleNavigationKeydown = (e) => {
        const focusedButton = document.activeElement;
        if (focusedButton.nodeName === "BUTTON") {
            const currentIndex = buttons.indexOf(focusedButton);
            const isFirstOrLast = e.key === "Home" || e.key === "End";
            const isArrowKey = e.key === "ArrowRight" || e.key === "ArrowLeft";
            if (isFirstOrLast) {
                setActive(buttons[e.key === "Home" ? 0 : buttons.length - 1]);
            } else if (isArrowKey) {
                const newIndex = calculateNewIndex(e.key, currentIndex);
                setActive(buttons[newIndex]);
            }
        }
    };

    const calculateNewIndex = (key, currentIndex) => {
        const offset = key === "ArrowRight" ? 1 : -1;
        return (currentIndex + offset + buttons.length) % buttons.length;
    };

    const setActive = (newActiveButton) => {
        buttons.forEach((button) => button.classList.remove("active"));
        newActiveButton.classList.add("active");
        newActiveButton.focus();
        scrollToTarget(newActiveButton);
    };

    const scrollToTarget = (button) => {
        const targetId = button.dataset.target;
        const sectionId = button.dataset.section;
        const targetElement = targetId
            ? document.querySelector(`article-menu#${targetId}`)
            : null;
        const container = document.querySelector(`main-menu[data-section-id="${sectionId}"]`);
        // display none all other article-menu elements thats not target id;
        const articleMenus = document.querySelectorAll("article-menu");
        articleMenus.forEach((articleMenu) => {
            articleMenu.style.display = "block";
        });
        //make main-menu element height the same as target element height;
        //first make target element height auto;
        targetElement.style.height = "fit-content";
        container.style.height = targetElement.offsetHeight + "px";
        if (targetElement) {
            const containerOffset = container.getBoundingClientRect().left;
            const targetOffset = targetElement.getBoundingClientRect().left;
            if(targetId.includes('-1')){
                container.scrollTo({
                    left: 0,
                    behavior: "smooth"
                });
            }else{
                container.scrollTo({
                    left: targetOffset - containerOffset + container.scrollLeft,
                    behavior: "smooth"
                });
            }
        }
    };

    const handleAccordionClick = (event) => {
        const accordionHeader = event.currentTarget;
        accordionHeader.classList.toggle('active');
        //accordionContent is closest .nested-links
        const accordionContent = accordionHeader.querySelector('.nested-links')
        if (accordionContent.style.height === "auto") {
            accordionContent.style.height = "0px";
        } else {
            accordionContent.style.display = "auto";
        }
    };

    navigations.forEach((navigation) => {
        navigation.addEventListener("click", handleNavigationClick);
         navigation.addEventListener("keydown", handleNavigationKeydown);
    });
    accordionHeaders.forEach((header) => {
        header.addEventListener('click', handleAccordionClick);
    });
});